import { RequestService } from '../../services/RequestService';
import { GET_CITIZENSHIPS } from '../constants';

export const getCitizenships = payload => {
  return RequestService.get(GET_CITIZENSHIPS);
};
